// extracted by mini-css-extract-plugin
export var attachment = "_nl-a";
export var emailContainer = "_nl-4";
export var emailContentPaddedContainer = "_nl-b";
export var emailHeader = "_nl-6";
export var emailIframe = "_nl-3";
export var emailInfoIcon = "_nl-9";
export var emailShortenedSummary = "_nl-e";
export var infoDropdown = "_nl-0";
export var infoRowBoundedContent = "_nl-d";
export var internal = "_nl-5";
export var merchant = "_nl-8";
export var messageInputContainer = "_nl-h";
export var normal = "_nl-7";
export var replyCard = "_nl-f";
export var subtleButton = "_nl-1";
export var subtleButtonIconContainer = "_nl-2";
export var toggleViewRepliesButton = "_nl-c";
export var wrappingText = "_nl-g";